import { render, staticRenderFns } from "./saleorders.vue?vue&type=template&id=18fab568&"
import script from "./saleorders.vue?vue&type=script&lang=js&"
export * from "./saleorders.vue?vue&type=script&lang=js&"
import style0 from "./saleorders.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports